import React from 'react'

export default props => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0001 2.75C17.1081 2.75 21.2501 6.891 21.2501 12C21.2501 17.108 17.1081 21.25 12.0001 21.25C6.89109 21.25 2.75009 17.108 2.75009 12C2.75009 6.891 6.89109 2.75 12.0001 2.75Z"
        stroke="#004360"
        stroke-width="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9952 8.2041V12.6231"
        stroke="#004360"
        stroke-width="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.995 15.7959H12.005"
        stroke="#004360"
        stroke-width="2"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
